module.exports = __webpack_public_path__ + "static/img/popup.7f9b2ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/popup.png
// module id = Z+dd
// module chunks = 1